export const bingoLetters = ['b', 'i', 'n', 'g', 'o'];
